.RETDContainer
    width: 100%
    height: 100%
    display: flex
    flex-direction: row
    align-items: center
    gap: 10px
    padding: 0 20px
    stroke: rgb($globalSettingsFontPrimary)
    svg
        width: auto
        height: 24px
        stroke: none
.RETDDarkBg
    background: rgb($globalSettingsBackgroundSecondary)
